import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { swingLibraryService } from "../../../services/swingLibrary";
import { useInvalidate } from "../../../hooks/useInvalidate";

export function useAddTag() {
  const invalidate = useInvalidate();

  return useMutation({
    mutationFn: async ({ tag, userId }) => {
      try {
        return await swingLibraryService.addTag({ tag, type: "add", userId });
      } catch (error) {
        toast.error(error?.message ?? "Failed to create tag");
        throw error;
      }
    },
    onSuccess: async () => {
      await invalidate(["getSwingLibrarySettings_key"]);
      toast.success("Tag created");
    },
  });
}

export function useClearVideoTags() {
  const invalidate = useInvalidate();

  return useMutation({
    mutationFn: async ({ videoId }) => {
      try {
        return await swingLibraryService.updateVideoTags({
          tag: "",
          type: "clear",
          videoId,
        });
      } catch (error) {
        toast.error(error?.message ?? "Failed to clear tags");
        throw error;
      }
    },
    onSuccess: async () => {
      await invalidate(["getSwingList_key"]);
    },
  });
}

export function useUpdateVideoTags() {
  const invalidate = useInvalidate();

  return useMutation({
    mutationFn: async ({ tag, type, videoId }) => {
      try {
        return await swingLibraryService.updateVideoTags({
          tag,
          type,
          videoId,
        });
      } catch (error) {
        toast.error(error?.message ?? "Failed to update tags");
        throw error;
      }
    },
    onSuccess: async () => {
      await invalidate(["getSwingList_key"]);
    },
  });
}
